import React, { useEffect, useState, memo } from 'react';
import { Card, Table, Pagination, message } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import { useInjectSaga } from 'utils/injectSaga';
import { useInjectReducer } from 'utils/injectReducer';
import reducer, { initialState } from './reducer';
import saga from './saga';
import _ from 'lodash';
import categorySaga from 'pages/Category/saga';
import categoryReducer, { initialState as categoryInitialState } from 'pages/Category/reducer';
import { toggleDrawer, toggleDeleteModal, listDns } from './action';
import clientReducer, { initialState as clientInitialState } from 'pages/Client/reducer';
import clientSaga from 'pages/Client/saga';
import { DNSTableConfig } from './DNSTableConfig';
import AddAddonDNSDrawer from 'components/AddAddonDNSDrawer';
import orderReducer, { initialState as orderInitialState } from 'pages/Orders/reducer';
import orderSaga from 'pages/Orders/saga';

function AddDNS() {
  useInjectReducer({ key: 'dns', reducer });
  useInjectSaga({ key: 'dns', saga });
  useInjectReducer({ key: 'category', reducer: categoryReducer });
  useInjectSaga({ key: 'category', saga: categorySaga });
  useInjectReducer({ key: 'client', reducer: clientReducer });
  useInjectSaga({ key: 'client', saga: clientSaga });
  useInjectReducer({ key: 'order', reducer: orderReducer });
  useInjectSaga({ key: 'order', saga: orderSaga });
  const [columns, setColumns] = useState([]);
  const [searchText, setSearchText] = useState(null);
  const [searchedColumn, setSearchedColumn] = useState(null);
  // const [deleteModalToggle, setDeleteModalToggle] = useState(false);
  const [selectedDns, setselectedDns] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const dnsState = useSelector((state) => state.dns || initialState);
  const authState = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  useEffect(() => {
    const columns = DNSTableConfig(
      handleSearch,
      handleReset,
      editUserDns,
      authState.userResponsibilities,
    );
    setColumns(columns);
    dispatch(listDns({ page: 1, limit: 10 }));
  }, []);

  const resetPagination = () => setCurrentPage(1);

  const editUserDns = (email) => {
    setselectedDns(email);
    dispatch(toggleDrawer());
  };

  const onPageChange = (page, pageSize) => {
    let filter = { page, limit: pageSize };
    setCurrentPage(page);
    if ((searchedColumn, searchText)) {
      filter = { ...filter, [searchedColumn]: searchText };
    }
    dispatch(listDns(filter));
  };

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    if (selectedKeys.length <= 0) {
      message.error('Please select to search');
      return;
    }
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
    dispatch(listDns({ page: 1, limit: 10, [dataIndex]: selectedKeys[0] }));
    resetPagination();
  };
  // const handleDeleteModalToggle = () => dispatch(toggleDeleteModal());

  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText(null);
    setSearchedColumn(null);
    dispatch(listDns({ page: 1, limit: 10 }));
    resetPagination();
  };
  return (
    <>
      <Card
        title="Manage DNS Addon"
        extra={
          <AddAddonDNSDrawer
            initialState={initialState}
            categoryInitialState={categoryInitialState}
            clientInitialState={clientInitialState}
            selectedDns={selectedDns}
            orderInitialState={orderInitialState}
            resetPagination={resetPagination}
            editUserDns={editUserDns}
            roleAddResponsibility={_.includes(authState.userResponsibilities, 'ADD_DNS_ADDON')}
          />
        }
      >
        <Table
          columns={columns}
          loading={dnsState.loading}
          bordered
          pagination={false}
          size={'small'}
          dataSource={dnsState.data}
          style={{ height: '70vh', overflow: 'scroll' }}
        />
        <Pagination
          style={{ marginTop: '10px' }}
          total={dnsState.totalCount}
          showTotal={(total) => `Total ${total} items`}
          defaultPageSize={10}
          current={currentPage}
          showLessItems={true}
          showSizeChanger={false}
          disabled={dnsState.loading}
          onChange={onPageChange}
        />
      </Card>
      {/* <ConfirmModal
        title={'Delete Portfolio Confirmation'}
        text={'Are you sure you want to delete this portfolio ?'}
        toggle={dnsState.deleteModal}
        loading={dnsState.loading}
        handleDeleteModalToggle={handleDeleteModalToggle}
        onDelete={onDelete}
      /> */}
    </>
  );
}

export default AddDNS;
